import React, { Fragment, useEffect, useRef } from "react";
import "./MessageScreenFooter.css";
import { useState } from "react";
import { chatAction, messageAction } from "../../../../../store/action";
import { connect } from "react-redux";
import {
  chatSelector,
  globalStateSelector,
} from "../../../../../store/selector";
import {
  changeLastMessage,
  getHumanReadableDate,
} from "../../../../../dialpad/service/chat.service";
import { getTime, getUUID, removeElementById, removeSpecialCharactersAndGetLast10 } from "../../utils";
import { Alert, Spinner } from "modules/theme";
import { Col, Nav, Row, Tab, Tabs } from "react-bootstrap";
import {
  CannedResonse,
  SeachFormFooter,
  TabInnerBody,
  TabItemsStyle,
  TabItemsStyleFooter,
} from "./MessageFooter";
import Select from 'react-select-plus';
import MessageHelper from "../../../../../store/helper/message.helper";

const TypingIndicatorBubble = ({ name }) => (
  // <div className="typing-indicator-bubble">
  //   <div className="typing-dot"></div>
  //   <div className="typing-dot"></div>
  //   <div className="typing-dot"></div>
  // </div>
  <div className="typing-indicator-container">
    <div class="half light">
      <div class="typing">
        <span className="typing-text">{name} is typing </span>{" "}
        <span class="circle scaling"></span>
        <span class="circle scaling"></span>
        <span class="circle scaling"></span>
      </div>
    </div>
  </div>
);

const customStyles = {
  control: (base, state) => ({
    ...base,
    background: "#FFFFFF", // White background
    border: "1px solid #D9D9D9", // Light grey border
    borderRadius: "6px", // Rounded corners
    boxShadow: state.isFocused ? "0 0 0 2px #4A90E2" : "none", // Highlight on focus
    padding: "6px 12px", // Add padding
    fontSize: "14px",
    color: "#333", // Text color
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E6F7FF", // Light blue background for selected tags
    borderRadius: "4px", // Rounded corners for tags
    padding: "2px 6px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#1890FF", // Blue text for tags
    fontSize: "12px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#1890FF",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#1890FF",
      color: "white",
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#BFBFBF", // Grey color for dropdown arrow
    ":hover": {
      color: "#4A90E2", // Blue on hover
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#BFBFBF", // Placeholder grey
  }),
};


function MessageScreenFooter({
  showAttachBtn = true,
  customSendMessage,
  setCustomMessage,
  setIsFileAttached = false,
  hideInput,
  ...props
}) {
  const {
    selectedAssignedList,
    dynamicUpdate,
    unAssignedList,
    cannedMessages,
    typingIndicatorCus,
    currentUser,
    tagsListDispose,
    callTagList,
    dispose,
    activeTab,
    setActiveTab,
    messageTagsList,
    messageSelectedTag,
    messageCommentTag,
    messageFinalTag,
    messageListTag,
    setListRedux,
    setCurrentLevelTagsRedux,
    currentLevelTagsRedux,
    listDispose,
    joinLoading,
    messageList,
    isConnected,
    isOffline,
    replyTabMessage,
    privateTabMessage,
    messageReply,
    messagePrivate
  } = props;
  // tagsListDispose =
  // tagsListDispose && tagsListDispose.length
  //       ? tagsListDispose
  //       : [
  //           {
  //             name: "No Tags Found",
  //             _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
  //           },
  //         ];
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTag, setActiveTag] = useState("All");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [message, setMessage] = useState("");

  const [focusArea, setFocusArea] = useState("messages");
  const [filteredTags, setFilteredTags] = useState(cannedMessages.tagList);
  const [tagCounts, setTagCounts] = useState({});
  const tagList =
    showSuggestions && message.includes("/") && !message.includes("/#")
      ? ["All", ...filteredTags.filter((tag) => tagCounts[tag] > 0)]
      : filteredTags;
  const [activeTagIndex, setActiveTagIndex] = useState(
    tagList.indexOf(activeTag ? activeTag : "")
  );

  const [filteredMessages, setFilteredMessages] = useState(
    cannedMessages.messages
  );
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [isTyping, setIsTyping] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);

  const [selected, setSelected] = useState({});
  const [tags, setTags] = useState([]);

  const [messageMaxLength, setMessageMaxLength] = useState(1000);

  const flattenTags = (tags) => {
    if (!tags) return []; // Guard clause for empty or undefined tags
    return tags.map(tag => ({
      name: tag.name,
      _id: tag._id,
      children: tag.childs || [], // Ensure children is always an array
    }));
  };


  const [list, setList] = useState([]); // Initialize as an empty array
  const [selectedItems, setSelectedItems] = useState([]);
  const [isListOpen, setIsListOpen] = useState(false);
  const [currentLevelTags, setCurrentLevelTags] = useState([]);
  const dropdownRef = useRef(null);

  const replyTextareaRef = useRef(null);
  const privateNoteTextareaRef = useRef(null);

  useEffect(() => {
    if (replyTextareaRef.current) {
      replyTextareaRef.current.focus();
    }
  }, []);

  // const [callTagList, setCallTagList] = useState([]);

  // const [tagsList, setTagList] = useState(
  //   tagsList && tagsList.length
  //     ? tagsList
  //     : [
  //       {
  //         name: "No Tags Found",
  //         _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
  //       },
  //     ]);


  // const [activeTab, setActiveTab] = useState("reply");

  // useEffect(() => {
  //   if (messageTagsList) {
  //     const flattenedTags = flattenTags(messageTagsList);
  //     setList(flattenedTags);

  //     // Initially show parent tags (those with children) and tags without children
  //     setCurrentLevelTags(
  //       flattenedTags.filter(tag => (tag.children && tag.children.length > 0) || (tag.children && tag.children.length === 0))
  //     );
  //   }
  // }, [messageTagsList]);

  // useEffect(() => {
  //   if (messageTagsList && selectedAssignedList && selectedAssignedList.teamId) {

  //     if (
  //       messageTagsList.length === 0 &&
  //       messageTagsList[0].name === "No Tags Found" &&
  //       messageTagsList[0]._id === "d62d0ebc-607d-479f-ac14-fe314875258c"
  //     ) {

  //       const noTagsFallback = [
  //         {
  //           name: "No Tags Found",
  //           _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
  //         },
  //       ];

  //       // Set fallback directly to list and currentLevelTags
  //       setList(noTagsFallback);
  //       setListRedux(noTagsFallback);

  //       setCurrentLevelTags(noTagsFallback);
  //       setCurrentLevelTagsRedux(noTagsFallback);
  //       return; // Exit early as no further processing is needed
  //     }

  //     // Filter messageTagsList to include only entries with matching teamId
  //     const filteredMessageTagsList = messageTagsList.filter(
  //       (tags) => tags.teamId === selectedAssignedList.teamId
  //     );

  //     // Flatten the tags from the filtered list
  //     const flattenedTags = filteredMessageTagsList.flatMap((tags) =>
  //       flattenTags(tags.data)
  //     );

  //     setList(flattenedTags);
  //     setListRedux(flattenedTags);

  //     // Set current level tags (those with children or without children)
  //     setCurrentLevelTags(
  //       flattenedTags.filter(
  //         (tag) =>
  //           (tag.children && tag.children.length > 0) ||
  //           (tag.children && tag.children.length === 0)
  //       )
  //     );
  //     setCurrentLevelTagsRedux(
  //       flattenedTags.filter(
  //         (tag) =>
  //           (tag.children && tag.children.length > 0) ||
  //           (tag.children && tag.children.length === 0)
  //       ));

  //   }
  // }, [messageTagsList, selectedAssignedList]);

  useEffect(() => {
    if (!messageTagsList || !selectedAssignedList || !selectedAssignedList.teamId) {
      // Fallback for no data

      const noTagsFallback = [
        {
          name: "No Tags Found",
          _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
        },
      ];
      setList(noTagsFallback);
      setListRedux(noTagsFallback);
      setCurrentLevelTags(noTagsFallback);
      setCurrentLevelTagsRedux(noTagsFallback);
      return;
    }

    // Check if "No Tags Found" condition is met
    if (
      messageTagsList.length === 1 &&
      messageTagsList[0].name === "No Tags Found"
    ) {
      const noTagsFallback = [
        {
          name: "No Tags Found",
          _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
        },
      ];
      setList(noTagsFallback);
      setListRedux(noTagsFallback);
      setCurrentLevelTags(noTagsFallback);
      setCurrentLevelTagsRedux(noTagsFallback);
      return;
    }

    // Filter tags for the selected team
    const filteredMessageTagsList = messageTagsList.filter(
      (tags) => tags.teamId === selectedAssignedList.teamId
    );
    const flattenedTags = filteredMessageTagsList.flatMap((tags) =>
      flattenTags(tags.data)
    );

    // Update list and tags
    setList(flattenedTags);
    setListRedux(flattenedTags);
    setCurrentLevelTags(
      flattenedTags.filter(
        (tag) =>
          (tag.children && tag.children.length > 0) ||
          (tag.children && tag.children.length === 0)
      )
    );
    setCurrentLevelTagsRedux(
      flattenedTags.filter(
        (tag) =>
          (tag.children && tag.children.length > 0) ||
          (tag.children && tag.children.length === 0)
      )
    );
  }, [messageTagsList, selectedAssignedList]);


  useEffect(() => {
    if (setCustomMessage) {
      setCustomMessage(message);
    }
  }, [message]);

  useEffect(() => {
    // Update tag counts initially and whenever cannedMessages or filteredMessages change
    const updatedTagCounts = {};
    for (const tag of cannedMessages.tagList) {
      if (tag === "All") {
        updatedTagCounts[tag] = cannedMessages.messages.length;
      } else {
        updatedTagCounts[tag] = cannedMessages.messages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
    }
    setTagCounts(updatedTagCounts);
  }, [cannedMessages, cannedMessages.messages]);

  useEffect(() => {
    if (showSuggestions) {
      const handleKeyDown = (e) => {
        if (focusArea === "messages") {
          if (e.key === "ArrowDown") {
            setSelectedIndex((prevIndex) =>
              prevIndex < filteredMessages.length - 1
                ? prevIndex + 1
                : prevIndex
            );
          } else if (e.key === "ArrowUp") {
            setSelectedIndex((prevIndex) =>
              prevIndex > 0 ? prevIndex - 1 : prevIndex
            );
          } else if (e.key === "ArrowLeft") {
            setFocusArea("tags");
          } else if (e.key === "Enter") {
            e.preventDefault();
            handleSelectMessage(filteredMessages[selectedIndex]);
          }
        } else if (focusArea === "tags") {
          if (e.key === "ArrowDown") {
            setActiveTagIndex((prevIndex) =>
              prevIndex < tagList.length - 1 ? prevIndex + 1 : prevIndex
            );
            handleTagClick(filteredTags[activeTagIndex + 1]);
          } else if (e.key === "ArrowUp") {
            // setActiveTagIndex((prevIndex) =>
            //   prevIndex > 0 ? prevIndex - 1 : prevIndex
            // );
            // handleTagClick(filteredTags[activeTagIndex - 1]);
            if (activeTagIndex === 0) {
              setActiveTag("All"); // Set "All" tag active
              setFilteredMessages(cannedMessages.messages); // Show all messages
            } else {
              setActiveTagIndex((prevIndex) =>
                prevIndex > 0 ? prevIndex - 1 : prevIndex
              );
              handleTagClick(filteredTags[activeTagIndex - 1]);
            }
          } else if (e.key === "ArrowRight") {
            setFocusArea("messages");
          } else if (e.key === "Enter") {
            e.preventDefault();
            // handleTagClick(tagList[activeTagIndex]);
            handleSelectMessage(filteredMessages[selectedIndex]);
            // handleTagClick(filteredTags[activeTagIndex]);
          }
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [
    showSuggestions,
    filteredMessages,
    selectedIndex,
    focusArea,
    activeTagIndex,
    tagList,
  ]);

  const setAssignScreen = (value) => {
    if (value === false) {
      dynamicUpdate({ data: { key: "details.newUnAssignedUsers", value: 0 } });
    }
    dynamicUpdate({ data: { key: "details.assignScreen", value: value } });
  };

  const sendMessage = (e, type) => {
    const { configProcessor, messageList, assignedList, currentUser } = props;

    e.preventDefault();
    if (message.trim().length === 0) {
      return;
    }
    if (setCustomMessage) {
      return;
    }
    const messagePayload = {
      from: "agent",
      timeStamp: new Date().toISOString(),
      type: type === "privateMessage" ? 'privateText' : 'text',
      plateform:
        selectedAssignedList && selectedAssignedList.plateform
          ? selectedAssignedList.plateform
          : "",
      content: {
        text: message,
      },
      id: getUUID(),
    };
    const messageData = {
      userId: currentUser.userId,
      timeStamp: new Date().toISOString(),
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      message: messagePayload,
    };
    setMessage("");
    dynamicUpdate({
      data: { key: `messageReply_${selectedAssignedList.sessionId}`, value: "" },
    });
    dynamicUpdate({
      data: { key: `messagePrivate_${selectedAssignedList.sessionId}`, value: "" },
    });
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: type === "privateMessage" ? type : 'message',
      "rmq:pattern": "agent:message",
      id: messagePayload.id,
      message: {
        ...(selectedAssignedList && selectedAssignedList.message),
        ...messagePayload,
      },
    });

    changeLastMessage({
      list: assignedList,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assignedList",
    });
    dynamicUpdate({
      data: {
        key: `messageList.${selectedAssignedList.identifier}`,
        value: [
          messageData,
          ...(messageList[selectedAssignedList.identifier] || []),
        ],
      },
    });
  };

  function isTotalFileSizeValid(selectedFiles) {
    const maxSizeBytes = 5 * 1024 * 1024; // 5MB in bytes
    let totalSize = 0;

    for (const file of selectedFiles) {
      totalSize += file.size;
    }

    return totalSize <= maxSizeBytes;
  }

  const fileInput = (e) => {
    if (!isTotalFileSizeValid(e.target.files)) {
      Alert.error("Total file size should be less than 5MB");
      return;
    }
    if (e && e.target && e.target.files[0]) {
      if (e.target.files[0].type.startsWith("audio/")) {
        dynamicUpdate({
          data: { key: "selectedAudio", value: e.target.files },
        });
      } else if (e.target.files[0].type.startsWith("image/")) {
        dynamicUpdate({
          data: { key: "selectedImages", value: e.target.files },
        });
      } else if (
        e.target.files[0].type === "application/msword" || // for doc
        e.target.files[0].type === "application/pdf" || // for pdf
        e.target.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        e.target.files[0].type === "text/plain" // for txt
      ) {
        dynamicUpdate({ data: { key: "selectedDocs", value: e.target.files } });
      } else {
        Alert.error("Unsupported file type");
      }
    } else {
      Alert.error("No file selected");
    }


  };

  const assign = (e) => {
    const { configProcessor, assignedList } = props;
    e.preventDefault();
    dynamicUpdate({ data: { key: `joinLoading_${selectedAssignedList.identifier}`, value: true } });
    // const newUnassignedList = removeElementById(
    //   unAssignedList,
    //   "identifier",
    //   selectedAssignedList.identifier
    // );
    // dynamicUpdate({
    //   data: { key: "unAssignedList", value: newUnassignedList },
    // });
    // configProcessor(`messageTagList`, { teamId: selectedAssignedList.teamId });
    if (!messageList[selectedAssignedList.identifier]) {
      configProcessor("getHistory", {
        identifier: selectedAssignedList.identifier,
      });
    }
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      "rmq:pattern": "agent:event",
      payloadType: "event",
      eventMessage: {
        from: "agent",
        type: "assign",
      },
    });
    if (messageTagsList) {
      // Check if there is any entry in messageTagsList with the same teamId as listData.teamId
      const isTeamIdMatched = messageTagsList.some(tag => tag.teamId === selectedAssignedList.teamId);

      if (!isTeamIdMatched) {
        // If no match is found, send the request
        configProcessor(`messageTagList`, { teamId: [selectedAssignedList.teamId] });
      } else {
        // If teamId matches, do not send the request
        console.log("Team ID matches, no request sent.");
      }
    }
    // configProcessor(`messageTagList`, { teamId: [selectedAssignedList.teamId] });
    try {
      MessageHelper.iframeEvent("softphoneCallInvited", {
        "from": {
          "number": removeSpecialCharactersAndGetLast10(selectedAssignedList.customer && selectedAssignedList.customer.phoneNumber ? selectedAssignedList.customer.phoneNumber : ""),
        }
      });
    } catch (error) {
      console.log(`iframeEvent error softphoneCallInvited`, error);
    }
    // dynamicUpdate({
    //   data: {
    //     key: "assignedList",
    //     value: [selectedAssignedList, ...(assignedList && assignedList)],
    //   },
    // });
    // dynamicUpdate({
    //   data: {
    //     key: `assignedList.${selectedAssignedList.identifier}`,
    //     value: [
    //       selectedAssignedList,
    //       ...(messageList[selectedAssignedList.identifier] || []),
    //     ],
    //   },
    // });
    // setAssignScreen(true);
    // dynamicUpdate({
    //   data: { key: "selectedAssignedList", value: selectedAssignedList },
    // });
  };

  function highlightText(text, highlight) {
    if (!highlight) return text;
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="highlighted">
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  const handleInputChangePrivateNote = (e) => {
    const { configProcessor } = props;
    const value = e.target.value;
    setMessage(value);
    setSearchQuery(e.target.value);
    dynamicUpdate({
      data: { key: `messagePrivate_${selectedAssignedList.sessionId}`, value: value },
    });
  }

  const handleInputChange = (e) => {
    const { configProcessor } = props;
    const value = e.target.value;
    setMessage(value);
    setSearchQuery(e.target.value);

    dynamicUpdate({
      data: { key: `messageReply_${selectedAssignedList.sessionId}`, value: value },
    });
    if (!isTyping) {
      setIsTyping(true);
      // Emit typing event to the server here if needed
      const messagePayload = {
        from: "agent",
        timeStamp: new Date().toISOString(),
        type: "typing",
        plateform:
          selectedAssignedList && selectedAssignedList.plateform
            ? selectedAssignedList.plateform
            : "",
        content: {

        },
        id: getUUID(),
      };
      configProcessor("sendPayload", {
        ...selectedAssignedList,
        "rmq:pattern": "agent:event",
        payloadType: "event",
        eventMessage: {
          from: "agent",
          type: "typing",
        },
        message: {
          ...(selectedAssignedList && selectedAssignedList.message),
          ...messagePayload,
        },
        message: {
          // content: {
          //   count: 0,
          //   data: null,
          // },
          // from: "agent",
          // id: getUUID(),
          // plateform: selectedAssignedList && selectedAssignedList.plateform
          //   ? selectedAssignedList.plateform
          //   : "",
          // timeStamp: new Date().toISOString(),
          // type: "typing"
        },
      });

      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      setTypingTimeout(
        setTimeout(() => {
          setIsTyping(false);
          // Emit stop typing event to the server here if needed
        }, 5000)
      ); // Adjust the timeout as needed
    }

    if (value.includes("/#")) {
      setShowSuggestions(true);
      const tagFilter = value
        .split("/#")
        .pop()
        .toLowerCase();
      const matchedMessages = cannedMessages.messages.filter((msg) =>
        msg.tags.some((tag) => tag.includes(tagFilter))
      );
      const matchedTags = cannedMessages.tagList.filter((tag) =>
        tag.includes(tagFilter)
      );
      setFilteredMessages(matchedMessages);
      setFilteredTags(matchedTags);
      if (matchedTags.length > 0) {
        setActiveTag(matchedTags[0]); // Set the first matched tag as active
        setActiveTagIndex(0);
      } else {
        setActiveTag("");
        setActiveTagIndex(-1);
      }
      const updatedTagCounts = {};
      for (const tag of matchedTags) {
        updatedTagCounts[tag] = matchedMessages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
      setTagCounts(updatedTagCounts);
    } else if (value.includes("//") && !value.includes(" /")) {
      // Check for multiple slashes
      setShowSuggestions(false); // Close suggestion box for multiple consecutive slashes
      setFilteredMessages(cannedMessages.messages);
      setFilteredTags(cannedMessages.tagList);
      setActiveTag("All"); // Reset active tag to 'All'
      setActiveTagIndex(-1);
      const updatedTagCounts = {};
      for (const tag of cannedMessages.tagList) {
        updatedTagCounts[tag] = cannedMessages.messages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
      setTagCounts(updatedTagCounts);
    } else if (value.match(/\s\/\/\//)) {
      // Check for space followed by multiple slashes
      setShowSuggestions(true);
      // const slashFilter = value
      //   .split("/")
      //   .pop()
      //   .toLowerCase();
      const slashFilter = value.split(/\/(.+)/)[1].toLowerCase();
      const matchedMessages = cannedMessages.messages.filter((msg) =>
        msg.message.toLowerCase().includes(slashFilter)
      );
      setFilteredMessages(matchedMessages);
      setFilteredTags(cannedMessages.tagList); // Reset tags to all available tags when not filtering by tag
      setActiveTag("All"); // Reset active tag to 'All'
      setActiveTagIndex(-1);
      const updatedTagCounts = {};
      for (const tag of cannedMessages.tagList) {
        updatedTagCounts[tag] = matchedMessages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
      setTagCounts(updatedTagCounts);
    } else if (value.charAt(0) === "/" || value.includes(" /")) {
      setShowSuggestions(true);
      const textFilter = value
        .split("/")
        .pop()
        .toLowerCase();
      const matchedMessages = cannedMessages.messages.filter((msg) =>
        msg.message.toLowerCase().includes(textFilter)
      );
      setFilteredMessages(matchedMessages);
      setFilteredTags(cannedMessages.tagList); // Reset tags to all available tags when not filtering by tag
      setActiveTag("All"); // Reset active tag to 'All'
      setActiveTagIndex(-1);
      const updatedTagCounts = {};
      for (const tag of cannedMessages.tagList) {
        updatedTagCounts[tag] = matchedMessages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
      setTagCounts(updatedTagCounts);
    } else {
      setShowSuggestions(false);
      setFilteredMessages(cannedMessages.messages);
      setFilteredTags(cannedMessages.tagList);
      setActiveTag("All"); // Reset active tag to 'All'
      setActiveTagIndex(-1);
      const updatedTagCounts = {};
      for (const tag of cannedMessages.tagList) {
        updatedTagCounts[tag] = cannedMessages.messages.filter((msg) =>
          msg.tags.includes(tag)
        ).length;
      }
      setTagCounts(updatedTagCounts);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && message.trim().length > 0) {
      if (message.trim() === "/") {
        // Don't send the message if it's just "/"
        e.preventDefault();
        return;
      }

      e.preventDefault();
      if (activeTab === "reply") {
        customSendMessage ? customSendMessage() : sendMessage(e, "text");
      } else if (activeTab === "privateNote") {
        customSendMessage
          ? customSendMessage()
          : sendMessage(e, "privateMessage");
      }
    }
  };

  const handleOnPaste = (event) => {
    // Prevent default paste behavior
    event.preventDefault();

    // Get plain text from clipboard
    const text = (event.clipboardData || window.clipboardData).getData('text');

    // Use Document.execCommand to insert text
    document.execCommand('insertText', false, text);

    // Update your state or perform additional actions
    // setMessage(text);
  };

  const handleTagClick = (tag) => {
    setActiveTag(tag);
    setSelectedIndex(0);
    if (tag === "All") {
      setFilteredMessages(cannedMessages.messages);
    } else {
      const matchedMessages = cannedMessages.messages.filter((msg) =>
        msg.tags.includes(tag)
      );
      setFilteredMessages(matchedMessages);
    }
  };

  // const handleSelectMessage = (selectedMessage) => {
  //   selectedMessage
  //     ? (setMessage(message.split("/")[0] + selectedMessage.message),
  //       setShowSuggestions(false))
  //     : setShowSuggestions(false);
  // };

  const handleSelectMessage = (selectedMessage) => {
    if (selectedMessage) {
      const lastSpaceSlashIndex = message.lastIndexOf(" /");
      const firstSlashIndex = message.indexOf("/");

      let newMessage;

      if (lastSpaceSlashIndex !== -1) {
        // Case: slash after a space
        newMessage =
          message.substring(0, lastSpaceSlashIndex) +
          " " +
          selectedMessage.message;
      } else if (firstSlashIndex !== -1) {
        // Case: first typed slash
        newMessage =
          message.substring(0, firstSlashIndex) + selectedMessage.message;
      } else {
        // No slash found, just append the selected message
        newMessage = message + selectedMessage.message;
      }

      setMessage(newMessage);
      dynamicUpdate({
        data: { key: `messageReply_${selectedAssignedList.sessionId}`, value: newMessage },
      });
      setShowSuggestions(false);
    } else {
      setShowSuggestions(false);
    }
  };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault(); // Prevent default form submission behavior

  //     if (showSuggestions && selectedSuggestion) {
  //       // If suggestions are visible and one is selected, choose that canned message
  //       handleSelectMessage(selectedSuggestion);
  //     } else {
  //       // Here, you send the message excluding only `/`
  //       if (message.trim() !== "/") {
  //         sendMessage(message); // Send the message normally if it's not just `/`
  //       }
  //       setMessage(""); // Clear the textarea
  //     }
  //   }
  // };
  // const handleSendMessage = () => {
  //   // Logic to send the message
  //   setMessage("");
  // };

  // const tagCounts = cannedMessages.tagList.reduce((counts, tag) => {
  //   counts[tag] = cannedMessages.messages.filter((msg) =>
  //     msg.tags.includes(tag)
  //   ).length;
  //   return counts;
  // }, {});

  const handleMouseEvents = (tag) => {
    setActiveTag(tag);
    handleTagClick(tag);
  };

  const isSelectedInUnassigned = unAssignedList.some(
    (item) => item.id === selectedAssignedList.id
  );

  const buttonStyle = {
    color: message.trim().length > 0 || setIsFileAttached ? "#4860D9" : "#d9d9d9",
    cursor: message.trim().length > 0 || setIsFileAttached ? "pointer" : "not-allowed",
  };


  const tagProcessor = (tagList, items) => {
    // if( selected )
    let list = [];
    if (items && items.length) {
      for (const disposeId of items) {
        if (disposeId) {
          let hasList = false;
          for (const tag of tagList) {
            if (tag._id == disposeId) {
              hasList = true;
              list.push({
                label: tag.name,
                value: tag._id,
                // ...el
              });
              if (tag.childs && tag.childs.length) {
                tagList = tag.childs;
              } else {
                tagList = [];
              }
              break;
            }
          }
          if (!hasList) {
            console.log("Break");
            break;
          }
        }
      }
    } else {
      if (!tagList || tagList.length == 0) {
        tagList = [
          {
            name: "No Tags Found",
            _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
          },
        ];
      }
    }
    tagList.forEach((el) => {
      list.push({
        label: el.name,
        value: el._id,
        // ...el
      });
    });
    return list;
  }
  // const checkDispose = (items, messageTagsList) => {
  //   let listTag = [];
  //   let finalTag = {};
  //   let levelWise = {};
  //   let currentLevel = 0;
  //   items = items || [];
  //   messageTagsList = messageTagsList || [];
  //   for (const dispose of items) {
  //     if (dispose._id) {
  //       if (dispose._id == "fallback-no-tags-redux") {
  //         finalTag = dispose;
  //         levelWise[`level${currentLevel}`] = {
  //           name: "No Tags Found",
  //           _id: dispose._id,
  //         };
  //         finalTag["finalLevel"] = currentLevel;
  //         finalTag["label"] = "No Tags Found";
  //         finalTag["value"] = dispose._id;
  //         finalTag["name"] = "No Tags Found";
  //         finalTag["_id"] = dispose._id;
  //         listTag.push(dispose._id);
  //         break;
  //       } else {
  //         let hasList = false;
  //         for (const tag of messageTagsList) {
  //           if (tag._id == dispose._id) {
  //             hasList = true;
  //             if (tag.childs && tag.childs.length) {
  //               messageTagsList = tag.childs;
  //               if (tag._id) {
  //                 levelWise[`level${currentLevel}`] = {
  //                   name: tag.name || "",
  //                   _id: tag._id,
  //                 };
  //               }
  //               currentLevel++;
  //             } else {
  //               finalTag = tag;
  //               levelWise[`level${currentLevel}`] = {
  //                 name: tag.name,
  //                 _id: tag._id,
  //               };
  //               delete finalTag.childs;
  //               delete finalTag.create_at;
  //               delete finalTag.createBy;
  //               finalTag["finalLevel"] = currentLevel;
  //               finalTag["label"] = tag.name;
  //               finalTag["value"] = tag._id;
  //             }
  //             break;
  //           }
  //         }
  //         if (!hasList) {
  //           break;
  //         }
  //       }

  //       listTag.push(dispose._id);
  //     }
  //   }
  //   if (finalTag && finalTag._id) {
  //     finalTag = { ...finalTag, ...levelWise };
  //   }
  //   return { listTag, finalTag };
  //   // try {
  //   //   if ( isNaN(dispose.value) ){
  //   //     dispose.value2 = dispose.value;
  //   //     dispose.value = "333";
  //   //   } else {
  //   //     dispose.value2 = "d62d0ebc-607d-479f-ac14-fe314875258c";
  //   //   }
  //   // } catch (error) {
  //   // }
  // }


  // const handleSelect = (item) => {

  //   const matchedMessageTagsList = messageTagsList.find(
  //     (tags) => tags.teamId === selectedAssignedList.teamId
  //   );

  //   if (!matchedMessageTagsList) {
  //     console.warn("No matching tags for the selected team's teamId.");
  //     return;
  //   }

  //   let { listTag, finalTag } = checkDispose([...selectedItems, item], matchedMessageTagsList.data);

  //   dynamicUpdate({
  //     data: { key: "messageListTag", value: listTag },
  //   });

  //   dynamicUpdate({
  //     data: { key: "messageFinalTag", value: finalTag },
  //   });

  //   setSelectedItems([...selectedItems, item]);
  //   dynamicUpdate({
  //     data: { key: "messageSelectedTag", value: [...selectedItems, item] },
  //   });

  //   if (item.children && item.children.length > 0) {
  //     setCurrentLevelTags(item.children);
  //   } else {
  //     setIsListOpen(false);
  //   }

  //   // Remove the selected item from the list
  //   setList(list.filter((i) => i._id !== item._id));
  // };

  // const handleSelect = (item) => {

  //   // Handle the "No Tags Found" case
  //   if (item.name === "No Tags Found" && item._id === "d62d0ebc-607d-479f-ac14-fe314875258c") {
  //     console.warn("No Tags Found selected. Passing messageTagsList directly to checkDispose.");

  //     let { listTag, finalTag } = checkDispose([item], messageTagsList);

  //     dynamicUpdate({
  //       data: { key: "messageListTag", value: listTag },
  //     });

  //     dynamicUpdate({
  //       data: { key: "messageFinalTag", value: finalTag },
  //     });

  //     setSelectedItems([item]);
  //     dynamicUpdate({
  //       data: { key: "messageSelectedTag", value: [item] },
  //     });

  //     if (item.children && item.children.length > 0) {
  //       setCurrentLevelTags(item.children);
  //       setCurrentLevelTagsRedux(item.children);
  //     } else {
  //       setIsListOpen(false);
  //     }

  //     // Remove the selected item from the list
  //     setList(list.filter((i) => i._id !== item._id));
  //     setListRedux(listDispose.filter((i) => i._id !== item._id));
  //     return; // Exit early
  //   }

  //   // Check for matching teamId in messageTagsList
  //   const matchedMessageTagsList = messageTagsList.find(
  //     (tags) => tags.teamId === selectedAssignedList.teamId
  //   );

  //   if (!matchedMessageTagsList) {
  //     console.warn("No matching tags for the selected team's teamId.");
  //     // Optionally, you can return here to prevent further execution:
  //     return;
  //   }

  //   // Normal flow for other items
  //   let { listTag, finalTag } = checkDispose([...selectedItems, item], matchedMessageTagsList.data);

  //   dynamicUpdate({
  //     data: { key: "messageListTag", value: listTag },
  //   });

  //   dynamicUpdate({
  //     data: { key: "messageFinalTag", value: finalTag },
  //   });

  //   setSelectedItems([...selectedItems, item]);
  //   dynamicUpdate({
  //     data: { key: "messageSelectedTag", value: [...selectedItems, item] },
  //   });

  //   if (item.children && item.children.length > 0) {
  //     setCurrentLevelTags(item.children);
  //     setCurrentLevelTagsRedux(item.children);
  //   } else {
  //     setIsListOpen(false);
  //   }

  //   // Remove the selected item from the list
  //   setList(list.filter((i) => i._id !== item._id));
  //   setListRedux(listDispose.filter((i) => i._id !== item._id));
  // };

  // const handleSelect = (item, listKey) => {

  //   // Handle the "No Tags Found" case
  //   if (item.name === "No Tags Found" && item._id === "d62d0ebc-607d-479f-ac14-fe314875258c") {
  //     console.warn("No Tags Found selected. Passing messageTagsList directly to checkDispose.");

  //     let { listTag, finalTag } = checkDispose([item], messageTagsList);

  //     dynamicUpdate({
  //       data: { key: `messageListTag_${selectedAssignedList.sessionId}`, value: listTag },
  //     });

  //     dynamicUpdate({
  //       data: { key: `messageFinalTag_${selectedAssignedList.sessionId}`, value: finalTag },
  //     });

  //     // setSelectedItems([item]);
  //     setSelectedItems(prevState => ({
  //       ...prevState,
  //       [listKey]: [item], // Update the selected items for this listKey
  //     }));
  //     dynamicUpdate({
  //       data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: [item] },
  //     });

  //     if (item.children && item.children.length > 0) {
  //       setCurrentLevelTags(item.children);
  //       setCurrentLevelTagsRedux(item.children);
  //     } else {
  //       setIsListOpen(false);
  //     }

  //     // Remove the selected item from the list
  //     setList(list.filter((i) => i._id !== item._id));
  //     setListRedux(listDispose.filter((i) => i._id !== item._id));
  //     return; // Exit early
  //   }

  //   // Check for matching teamId in messageTagsList
  //   const matchedMessageTagsList = messageTagsList.find(
  //     (tags) => tags.teamId === selectedAssignedList.teamId
  //   );

  //   if (!matchedMessageTagsList) {
  //     console.warn("No matching tags for the selected team's teamId.");
  //     return;
  //   }

  //   // Logic to handle tag selection (parent + children)
  //   let updatedSelectedItems = [...selectedItems];

  //   // If the item is a parent tag and there's already a parent tag selected, replace it
  //   if (item.children && item.children.length > 0) {
  //     // Remove any previously selected parent tags (if any)
  //     updatedSelectedItems = updatedSelectedItems.filter(i => !i.children);

  //     // Add the new parent tag
  //     updatedSelectedItems = [...updatedSelectedItems, item];
  //   } else {
  //     // Otherwise, just add the item
  //     updatedSelectedItems = [...updatedSelectedItems, item];
  //   }

  //   // Ensure only the selected parent and child tags are in the selected items
  //   updatedSelectedItems = Array.from(new Set(updatedSelectedItems.map(a => a._id)))
  //     .map(id => updatedSelectedItems.find(a => a._id === id));

  //   // Dispose tags
  //   let { listTag, finalTag } = checkDispose(updatedSelectedItems, matchedMessageTagsList.data);

  //   dynamicUpdate({
  //     data: { key: `messageListTag_${selectedAssignedList.sessionId}`, value: listTag },
  //   });

  //   dynamicUpdate({
  //     data: { key: `messageFinalTag_${selectedAssignedList.sessionId}`, value: finalTag },
  //   });

  //   // Update selected items
  //   // setSelectedItems(updatedSelectedItems);
  //   setSelectedItems(prevState => ({
  //     ...prevState,
  //     [listKey]: updatedSelectedItems, // Update only the selected items for the specific listKey
  //   }));
  //   dynamicUpdate({
  //     data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: updatedSelectedItems },
  //   });

  //   // Update the tags for the next level (if any children exist)
  //   if (item.children && item.children.length > 0) {
  //     setCurrentLevelTags(item.children);
  //     setCurrentLevelTagsRedux(item.children);
  //   } else {
  //     setIsListOpen(false);
  //   }

  //   // Remove the selected item from the list
  //   // setList(list.filter((i) => i._id !== item._id));
  //   // setListRedux(listDispose.filter((i) => i._id !== item._id));
  // };

  const checkDispose = (items, messageTagsList) => {
    let listTag = [];
    let finalTag = {};
    let levelWise = {};
    let currentLevel = 0;
    items = items || [];
    messageTagsList = messageTagsList || [];

    for (const dispose of items) {
      if (dispose._id) {
        if (dispose._id === "fallback-no-tags-redux") {
          finalTag = dispose;
          levelWise[`level${currentLevel}`] = {
            name: "No Tags Found",
            _id: dispose._id,
          };
          finalTag["finalLevel"] = currentLevel;
          finalTag["label"] = "No Tags Found";
          finalTag["value"] = dispose._id;
          finalTag["name"] = "No Tags Found";
          finalTag["_id"] = dispose._id;
          listTag.push(dispose._id);
          break;
        } else {
          let hasList = false;
          for (const tag of messageTagsList) {
            if (tag._id === dispose._id) {
              hasList = true;
              if (tag.children && tag.children.length) {
                messageTagsList = tag.children;
                levelWise[`level${currentLevel}`] = {
                  name: tag.name || "",
                  _id: tag._id,
                };
                currentLevel++;
              } else if (tag.childs && tag.childs.length) {
                messageTagsList = tag.childs;
                levelWise[`level${currentLevel}`] = {
                  name: tag.name || "",
                  _id: tag._id,
                };
                currentLevel++;
              } else {
                finalTag = tag;
                levelWise[`level${currentLevel}`] = {
                  name: tag.name,
                  _id: tag._id,
                };
                delete finalTag.childs;
                delete finalTag.create_at;
                delete finalTag.createBy;
                finalTag["finalLevel"] = currentLevel;
                finalTag["label"] = tag.name;
                finalTag["value"] = tag._id;
              }
              break;
            }
          }
          if (!hasList) {
            console.log("Break");
            break;
          }
        }

        listTag.push(dispose._id);
      }
    }
    if (finalTag && finalTag._id) {
      finalTag = { ...finalTag, ...levelWise };
    }
    return { listTag, finalTag };
  };

  // const handleSelect = (item, listKey) => {
  //   if (item.name === "No Tags Found" && item._id === "fallback-no-tags-redux") {
  //     console.warn("No Tags Found selected. Passing messageTagsList directly to checkDispose.");
  //     let { listTag, finalTag } = checkDispose([item], messageTagsList);

  //     dynamicUpdate({
  //       data: { key: `messageListTag_${selectedAssignedList.sessionId}`, value: listTag },
  //     });
  //     dynamicUpdate({
  //       data: { key: `messageFinalTag_${selectedAssignedList.sessionId}`, value: finalTag },
  //     });

  //     setSelectedItems((prevState) => ({
  //       ...prevState,
  //       [listKey]: [item],
  //     }));
  //     dynamicUpdate({
  //       data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: [item] },
  //     });

  //     if (item.children && item.children.length > 0) {
  //       setCurrentLevelTags(item.children);
  //       setCurrentLevelTagsRedux(item.children);
  //     } else {
  //       setIsListOpen(false);
  //     }

  //     setList(list.filter((i) => i._id !== item._id));
  //     setListRedux(listDispose.filter((i) => i._id !== item._id));
  //     return;
  //   }

  //   const matchedMessageTagsList = messageTagsList.find(
  //     (tags) => tags.teamId === selectedAssignedList.teamId
  //   );

  //   if (!matchedMessageTagsList) {
  //     console.warn("No matching tags for the selected team's teamId.");
  //     return;
  //   }
  //   // Initialize `selectedItems[listKey]` if undefined
  //   // let updatedSelectedItems = [...(selectedItems[listKey] || [])];
  //   let updatedSelectedItems = [];

  //   if (item.children && item.children.length > 0) {
  //     // If a parent tag is selected, only select the parent
  //     updatedSelectedItems = [item];
  //   } else {
  //     // If a child tag is selected, include its parent along with the child
  //     const parent = list.find((parentItem) =>
  //       parentItem.children && parentItem.children.some((child) => child._id === item._id)
  //     );

  //     if (parent) {
  //       updatedSelectedItems = [parent, item];
  //     } else {
  //       updatedSelectedItems = [item]; // If no parent is found, just select the item
  //     }
  //   }

  //   // if (item.children && item.children.length > 0) {
  //   //   // If the selected tag has children (i.e., it's a parent tag)
  //   //   // Ensure the parent tag is added to the list, but do not add children automatically
  //   //   updatedSelectedItems = updatedSelectedItems.filter(i => !i.children); // Remove any previous instances of this parent tag
  //   //   updatedSelectedItems = [...updatedSelectedItems, item]; // Add the parent tag to the list
  //   // } else {
  //   //   // If the selected item is a child (i.e., it does not have children)
  //   //   // Add the child tag to the list without removing any parent tag
  //   //   // updatedSelectedItems = [...updatedSelectedItems, item];
  //   //   if (!updatedSelectedItems.some(i => i._id === item._id)) {
  //   //     updatedSelectedItems = [...updatedSelectedItems, item]; // Add the child tag to the list
  //   //   }
  //   // }

  //   updatedSelectedItems = Array.from(new Set(updatedSelectedItems.map(a => a._id)))
  //     .map(id => updatedSelectedItems.find(a => a._id === id));

  //   const { listTag, finalTag } = checkDispose(updatedSelectedItems, matchedMessageTagsList.data);

  //   dynamicUpdate({
  //     data: { key: `messageListTag_${selectedAssignedList.sessionId}`, value: listTag },
  //   });
  //   dynamicUpdate({
  //     data: { key: `messageFinalTag_${selectedAssignedList.sessionId}`, value: finalTag },
  //   });
  //   setSelectedItems((prevState) => ({
  //     ...prevState,
  //     [listKey]: updatedSelectedItems,
  //   }));
  //   dynamicUpdate({
  //     data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: updatedSelectedItems },
  //   });

  //   if (item.children && item.children.length > 0) {
  //     setCurrentLevelTags(item.children);
  //     setCurrentLevelTagsRedux(item.children);
  //   } else {
  //     setIsListOpen(false);
  //   }
  // };


  // const handleRemove = (item) => {
  //   setList([...list, item]);
  //   setListRedux([...list, item]);
  //   setSelectedItems(selectedItems.filter((i) => i._id !== item._id));
  //   dynamicUpdate({
  //     data: { key: "messageSelectedTag", value: messageSelectedTag.filter((i) => i._id !== item._id) },
  //   });
  // };


  // const handleRemove = (item) => {
  //   // Remove the item and its children from the selected items
  //   const updatedSelectedItems = selectedItems.filter(
  //     (i) =>
  //       i._id !== item._id &&
  //       (!item.children || !item.children.some((child) => child._id === i._id))
  //   );

  //   setSelectedItems(updatedSelectedItems);
  //   dynamicUpdate({
  //     data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: updatedSelectedItems },
  //   });

  //   // Re-add the removed item to the list
  //   // const updatedList = [...list, item];
  //   // setList(updatedList);
  //   // setListRedux(updatedList);
  // // };
  const handleSelect = (item, listKey) => {

    const matchedMessageTagsList = messageTagsList.find(
      (tags) => tags.teamId === selectedAssignedList.teamId
    );

    if (!matchedMessageTagsList) {
      console.warn("No matching tags for the selected team's teamId.");
      return;
    }
    let updatedSelectedItems = selectedItems[listKey] ? [...selectedItems[listKey]] : [];

    // Remove previous selection from the same level
    updatedSelectedItems = updatedSelectedItems.filter(i => i.level !== item.level);

    // Add the new selection
    updatedSelectedItems.push(item);

    // Show next level if available
    if (item.children && item.children.length > 0) {
      setCurrentLevelTags(item.children);
      setCurrentLevelTagsRedux(item.children);
    } else if (item.childs && item.childs.length > 0) {
      setCurrentLevelTags(item.childs);
      setCurrentLevelTagsRedux(item.childs);
    } else {
      setIsListOpen(false);
    }

    const { listTag, finalTag } = checkDispose(updatedSelectedItems, matchedMessageTagsList.data);

    dynamicUpdate({
      data: { key: `messageListTag_${selectedAssignedList.sessionId}`, value: listTag },
    });
    dynamicUpdate({
      data: { key: `messageFinalTag_${selectedAssignedList.sessionId}`, value: finalTag },
    });

    setSelectedItems((prevState) => ({
      ...prevState,
      [listKey]: updatedSelectedItems,
    }));

    dynamicUpdate({
      data: { key: `messageSelectedTag_${selectedAssignedList.sessionId}`, value: updatedSelectedItems },
    });
  };



  // const handleRemove = (item, sessionKey) => {

  //   // Check if the selectedItems object exists and has the session key
  //   if (!selectedItems || !selectedItems[sessionKey] || !Array.isArray(selectedItems[sessionKey])) {
  //     console.error(`No valid selected items found for session: ${sessionKey}`);
  //     return;
  //   }

  //   // Get the current list of selected items for the session
  //   const sessionSelectedItems = selectedItems[sessionKey];

  //   // Filter out the item and its children from the selected items
  //   const updatedSessionSelectedItems = sessionSelectedItems.filter(
  //     (i) =>
  //       i._id !== item._id &&
  //       (!item.children || !item.children.some((child) => child._id === i._id))
  //   );

  //   // Update the selected items for the session
  //   const updatedSelectedItems = {
  //     ...selectedItems,
  //     [sessionKey]: updatedSessionSelectedItems,
  //   };

  //   // Update the state and Redux store
  //   setSelectedItems(updatedSelectedItems);
  //   dynamicUpdate({
  //     data: { key: `messageSelectedTag_${sessionKey}`, value: updatedSessionSelectedItems },
  //   });

  //   dynamicUpdate({
  //     data: { key: `messageFinalTag_${sessionKey}`, value: updatedSessionSelectedItems },
  //   });

  //   // Re-add the removed item to the list if it doesn't already exist
  //   // const updatedList = [...list];
  //   // if (!list.find((i) => i._id === item._id)) {
  //   //   updatedList.push(item);
  //   // }

  //   // Update the list state
  //   // setList(updatedList);
  //   // setListRedux(updatedList);
  // };


  // const handleToggleDropdown = () => {
  //   setIsListOpen(!isListOpen);
  //   if (!isListOpen) {
  //     // When opening the dropdown, show both parent tags (those with children) and tags without children
  //     setCurrentLevelTags(
  //       list.filter(tag => (tag.children && tag.children.length > 0) || (tag.children && tag.children.length === 0))
  //     );
  //     setCurrentLevelTagsRedux(
  //       listDispose.filter(tag => (tag.children && tag.children.length > 0) || (tag.children && tag.children.length === 0))
  //     )
  //   }
  // };

  const handleRemove = (item, sessionKey) => {

    // Check if there are selected items for the session.
    if (!selectedItems || !selectedItems[sessionKey] || !Array.isArray(selectedItems[sessionKey])) {
      console.error(`No valid selected items found for session: ${sessionKey}`);
      return;
    }

    const sessionSelectedItems = selectedItems[sessionKey];

    // Find the index of the tag to be removed.
    const index = sessionSelectedItems.findIndex(i => i._id === item._id);
    if (index === -1) {
      console.warn("Item not found in selected items");
      return;
    }

    // Remove the tag and all tags selected at deeper levels.
    const updatedSessionSelectedItems = sessionSelectedItems.slice(0, index);

    // Update state and redux.
    const updatedSelectedItems = {
      ...selectedItems,
      [sessionKey]: updatedSessionSelectedItems,
    };

    setSelectedItems(updatedSelectedItems);
    dynamicUpdate({
      data: { key: `messageSelectedTag_${sessionKey}`, value: updatedSessionSelectedItems },
    });
    dynamicUpdate({
      data: { key: `messageFinalTag_${sessionKey}`, value: updatedSessionSelectedItems },
    });
  };

  const handleToggleDropdown = () => {
    setIsListOpen(!isListOpen);

    if (!isListOpen) {
      const filteredTags = list.filter(
        tag => (tag.children && tag.children.length > 0) || (tag.children && tag.children.length === 0)
      );

      const filteredTagsRedux = listDispose.filter(
        tag => (tag.children && tag.children.length > 0) || (tag.children && tag.children.length === 0)
      );

      // If no tags are found, add the fallback option
      if (filteredTags.length === 0) {
        filteredTags.push({ name: "No Tags Found", _id: "fallback-no-tags" });
      }

      if (filteredTagsRedux.length === 0) {
        filteredTagsRedux.push({ name: "No Tags Found", _id: "fallback-no-tags-redux" });
      }

      setCurrentLevelTags(filteredTags);
      setCurrentLevelTagsRedux(filteredTagsRedux);
    }
  };


  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsListOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCountColor = () => {
    if (message.length > messageMaxLength)
      return "#dc2626"; // Exceeded
    // if (this.state.retrievalTest.length > this.state.retrievalMaxLength * 0.8)
    //   return "orange"; // Close to limit
    if (message.length > 0) return "#667085";
    return "#66708480"; // Under limit
  };

  const getBgColor = () => {
    if (message.length > messageMaxLength)
      return "#fee2e2"; // Exceeded
    if (message.length > 0) return "#f2f4f7";
    return "#f2f4f7";
  };

  return isSelectedInUnassigned ? (
    <div
      className={`message-screen-footer__main align-items-center justify-content-center`}
    >
      <div className="w-100 text-center">
        <button
          className="btn_style message-screen-footer__send-btn"
          onClick={(e) => {
            (isOffline || !isConnected) ? (
              Alert.error("You are Offline")
            ) : (
              assign(e)
            )
          }}
        >
          {joinLoading ? (
            <Spinner
              style={{
                height: "3px",
                marginTop: "-15px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
          ) : (
            "Join Conversation"
          )}
        </button>
      </div>
    </div>
  ) : (
    <div>
      {showSuggestions && (
        <CannedResonse>
          <TabItemsStyle>
            <div className="tabItemStyle">
              <Tabs defaultActiveKey="cannedResponse" id="">
                <Tab eventKey="cannedResponse" title="Canned responses">
                  <TabInnerBody className="h-100">
                    {filteredMessages.length > 0 ? (
                      <div className="tabComponent">
                        <div className="tabHeader">
                          <ul className="tabHeaderul">
                            {tagList.map((tag, index) => (
                              <li
                                key={tag}
                                className={`${activeTag === tag ? "active" : ""
                                  } tabHeaderli`}
                                onClick={() => handleTagClick(tag)}
                                // onMouseDown={() => handleMouseEvents(tag)}
                                // onMouseUp={() => handleMouseEvents(tag)}
                                style={
                                  activeTagIndex === index
                                    ? {
                                      // backgroundColor: "#dce9ff",
                                      // borderRadius: "8px",
                                    }
                                    : {
                                      borderRadius: "8px",
                                    }
                                }
                              >
                                <button>
                                  <p className="tabHeaderp">
                                    {highlightText(
                                      tag,
                                      searchQuery.split("/#").pop()
                                    )}{" "}
                                  </p>

                                  {/* <span>
                                    {tag === "All"
                                      ? Object.values(tagCounts).reduce(
                                          (acc, count) => acc + count,
                                          0
                                        )
                                      : filteredMessages.filter((msg) =>
                                          msg.tags.includes(tag)
                                        ).length}
                                  </span> */}
                                  <span>
                                    {tag === "All"
                                      ? Object.values(tagCounts).reduce(
                                        (acc, count) => acc + count,
                                        0
                                      )
                                      : tagCounts[tag]}
                                  </span>
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="tabContent h-100">
                          <ul className="tabContentul">
                            {filteredMessages.map((messageObj, index) => (
                              <li key={index}>
                                <div
                                  className={`tabContentdiv ${selectedIndex === index ? "selected" : ""
                                    }`}
                                  onClick={() =>
                                    handleSelectMessage(messageObj)
                                  }
                                >
                                  <p className="tabContentp">
                                    {highlightText(
                                      messageObj.message,
                                      searchQuery.slice(1)
                                    )}
                                  </p>
                                </div>
                                {filteredMessages.length !== 1 ? (
                                  <hr className="tabContenthr" />
                                ) : (
                                  ""
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <div className="noDataClass">
                        <span className="noDataClassSpan1">
                          Sorry, we can’t find any Canned responses.
                        </span>
                        <span className="noDataClassSpan2">
                          Try another search.
                        </span>
                      </div>
                    )}
                  </TabInnerBody>
                </Tab>
              </Tabs>
            </div>
          </TabItemsStyle>
        </CannedResonse>
      )}
      {/* {isTyping && <TypingIndicatorBubble />} */}

      {typingIndicatorCus && (
        <TypingIndicatorBubble name={selectedAssignedList.customer.display} />
      )}
      {/* {typingIndicatorCus && <div className="typing-indicator">User is typing...</div>} */}
      <form
        className={`message-screen-footer__main ${hideInput ? "message-screen-footer__main__end" : ""
          }`}
        // onSubmit={(e) => sendMessage(e, "text")}
        onSubmit={(e) => {
          e.preventDefault(); // Prevent default form submission

          if (activeTab === "reply") {
            customSendMessage ? customSendMessage() : sendMessage(e, "text");
          } else if (activeTab === "privateNote") {
            customSendMessage
              ? customSendMessage()
              : sendMessage(e, "privateMessage");
          }
        }}
      >
        <TabItemsStyleFooter>
          <div className="tabItemStyle">
            <Tabs
              defaultActiveKey="reply"
              activeKey={activeTab}
              id=""
              className="custom-tabs"
              // onSelect={(k) => {
              //   setActiveTab(k);
              //   setMessage(""); // Reset message when tab changes
              // }}
              onSelect={(k) => {
                if (!dispose || k === "dispose") {
                  setActiveTab(k); // Update activeTab in parent
                }
              }}
            >
              {/* <Tab eventKey="reply" title="Reply"> */}
              <Tab eventKey="reply" title={<span style={{ color: dispose ? "gray" : "black" }}>Reply</span>} disabled={dispose} onEntered={() => replyTextareaRef.current.focus()}>
                <div className="tab-content-style p-4">
                  <SeachFormFooter className="">
                    <textarea
                      className={`message-screen-footer__input ${hideInput ? "message-screen-footer__input_hide" : ""
                        }`}
                      ref={replyTextareaRef}
                      type="text"
                      value={messageReply || ""}
                      maxLength={1024}
                      autoFocus={true}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Enter message here..."
                      // onPaste={handleOnPaste}
                      onPaste={(e) => {
                        let paste = (e.clipboardData || window.clipboardData).getData(
                          "text"
                        );
                        if (paste.trim() === "") e.preventDefault();
                      }}
                      // onKeyPress={handleKeyPress}
                      style={{
                        padding: "6px 20px 0px 20px",
                        marginBottom: "0px",
                      }}
                    />
                    <span className="attach-btn" style={{ justifyContent: showAttachBtn ? ' space-between' : 'flex-end', }}>
                      {showAttachBtn && (
                        <div>
                          <label>
                            <span
                              class="material-symbols-outlined msg-screen-footer__btn-common msg-screen-footer__btn-common_attach_file"
                              onClick={() => { }}
                            >
                              attach_file
                            </span>
                            <input
                              multiple={true}
                              type="file"
                              id="file-upload"
                              name="img"
                              // accept="image/*, .doc, .pdf, .xml, .txt, .csv, .xlsx, .pptx, audio/*"
                              accept="image/jpeg, image/png, image/webp, image/gif, audio/mpeg, audio/ogg, audio/wav, audio/aac, audio/mp3, audio/m4a, audio/flac, audio/opus, video/mp4, video/x-matroska, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain"
                              style={{ display: "none" }}
                              onChange={fileInput}
                              onClick={(e) => (e.target.value = null)}
                            />
                          </label>
                        </div>
                      )}
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="bottom-div"
                          style={{
                            background: getBgColor(),
                            color: getCountColor(),
                          }}
                        >
                          {message.length}
                          <span class="bottom-span">/</span>
                          1024
                        </div>
                        <span
                          class="material-symbols-outlined"
                          style={buttonStyle}
                          onClick={(e) => {
                            e.preventDefault();
                            customSendMessage
                              ? customSendMessage()
                              : sendMessage(e, "text");
                          }}
                        >
                          send
                        </span>
                      </div>
                    </span>
                  </SeachFormFooter>
                </div>
              </Tab>
              {/* <Tab eventKey="privateNote" title="Private Notes"> */}
              <Tab eventKey="privateNote" title={<span style={{ color: dispose ? "gray" : "black" }}>Private Notes</span>} disabled={dispose || !showAttachBtn} onEntered={() => privateNoteTextareaRef.current.focus()}>
                <div
                  className="tab-content-style p-4"
                  style={{ background: "#F8F9FA" }}
                >
                  <SeachFormFooter className="">
                    <textarea
                      className={`message-screen-footer__input ${hideInput ? "message-screen-footer__input_hide" : ""
                        }`}
                      ref={privateNoteTextareaRef}
                      type="text"
                      maxLength={1024}
                      value={messagePrivate || ""}
                      onChange={handleInputChangePrivateNote}
                      onKeyDown={handleKeyDown}
                      placeholder="This will be visible only to Agents"
                      style={{
                        padding: "6px 20px 0px 20px",
                        marginBottom: "0px",
                      }}
                    />
                    <span className="attach-btn" style={{ width: "auto", bottom: '6px' }}>
                      <div
                        className="bottom-div mr-4"
                        style={{
                          background: getBgColor(),
                          color: getCountColor(),
                        }}
                      >
                        {message.length}
                        <span class="bottom-span">/</span>
                        1024
                      </div>
                      <span
                        class="material-symbols-outlined"
                        style={buttonStyle}
                        onClick={(e) =>
                          customSendMessage
                            ? customSendMessage()
                            : sendMessage(e, "privateMessage")
                        }
                      >
                        send
                      </span>
                    </span>
                  </SeachFormFooter>
                </div>
              </Tab>
              <Tab eventKey="dispose" title={<span style={{ color: "black" }}>Dispose</span>}>
                <div
                  className="tab-content-style p-4"
                  style={{ background: "#F8F9FA" }}
                >
                  <SeachFormFooter className="">
                    <textarea
                      className={`message-screen-footer__input ${hideInput ? "message-screen-footer__input_hide" : ""
                        }`}
                      type="text"
                      value={messageCommentTag || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        dynamicUpdate({
                          data: { key: `messageCommentTag_${selectedAssignedList.sessionId}`, value: value },
                        });
                      }}
                      placeholder="Type your comments..."
                      maxLength={400}
                      style={{
                        padding: "6px 20px 0px 20px",
                        marginBottom: "0px",
                      }}
                    />
                    <span className="attach-btn" style={{ bottom: '6px', justifyContent: 'space-between', padding: '0px 0px 0px 36px' }}>
                      {/* <Select
                        placeholder="Click here to Disposition Call"
                        onChange={(items) => {
                          if (items && items.length) {
                            let { list, finalTag } = checkDispose(items, tagsListDispose);
                            // this.setState({ selected: list, tags: list });
                            dynamicUpdate({ key: "callTagList", value: list });
                            dynamicUpdate({ key: "callTagFinalTag", value: finalTag });
                          } else {
                            // this.setState({ selected: [], tags: [] });
                            dynamicUpdate({ key: "callTagList", value: [] });
                            dynamicUpdate({ key: "callTagFinalTag", value: {} });
                          }
                        }}
                        value={callTagList}
                        options={tagProcessor(tagsListDispose, callTagList)}
                        multi={true}
                        removeSelected={true}
                        styles={customStyles}
                        className="custom-select"
                      /> */}

                      <div ref={dropdownRef} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <button
                          style={{
                            fontSize: '18px',
                            letterSpacing: '0.03em',
                            fontWeight: '600',
                            border: 'none',
                            background: 'transparent',
                            color: '#0566FF',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                          }}
                          onClick={handleToggleDropdown}
                        >
                          <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>
                            sell
                          </span>
                          Tags
                        </button>

                        {isListOpen && (
                          <ul
                            style={{
                              position: 'absolute', // Position the list absolutely below the button
                              left: 0,
                              borderRadius: '10px',
                              padding: '6px 14px',
                              backgroundColor: '#fff',
                              zIndex: 10,
                              bottom: '100%',
                              whiteSpace: 'nowrap',
                              listStyle: 'none',
                              color: '#000',
                              fontSize: '14px',
                              fontWeight: '600',
                              boxShadow: '0px 3px 20px rgb(0 0 0 / 10%)',
                              marginBottom: '5px',
                              maxHeight: '200px',
                              overflowY: 'auto',
                            }}
                          >
                            {Array.isArray(currentLevelTagsRedux) && currentLevelTagsRedux.length > 0 ? (
                              currentLevelTagsRedux.map((item) => (
                                <li
                                  key={item._id}
                                  style={{ cursor: 'pointer', padding: '5px' }}
                                  onClick={() => handleSelect(item, selectedAssignedList.sessionId)}
                                >
                                  {item.name}
                                </li>
                              ))
                            ) : (
                              <li>No Tags Found</li>
                            )}
                          </ul>
                        )}

                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          {messageSelectedTag && messageSelectedTag.map((item) => (
                            <button
                              key={item._id}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '3px 10px 3px 10px',
                                background: '#5C7AFF',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '50px',
                                fontSize: '14px',
                                fontWeight: '600',
                                lineHeight: '20px',
                              }}
                            >
                              {item.name}
                              <span
                                style={{
                                  marginLeft: '10px',
                                  cursor: 'pointer',
                                  fontSize: '20px',
                                }}
                                class="material-symbols-outlined"
                                onClick={() => handleRemove(item, selectedAssignedList.sessionId)}
                              >
                                close
                              </span>
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* <span
                        class="material-symbols-outlined"
                        // style={buttonStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          const messagePayload = {
                            from: "agent",
                            timeStamp: new Date().toISOString(),
                            type: "dispose",
                            plateform:
                              selectedAssignedList && selectedAssignedList.plateform
                                ? selectedAssignedList.plateform
                                : "",
                            content: {
                              comment: messageCommentTag,
                              tag: messageFinalTag
                            },
                            id: getUUID(),
                          };
                          props.configProcessor("dispose", {
                            ...selectedAssignedList,
                            payloadType: "event",
                            "rmq:pattern": "agent:event",
                            eventMessage: {
                              type: 'dispose',
                              from: 'agent'
                            },
                            message: {
                              ...(selectedAssignedList && selectedAssignedList.message),
                              ...messagePayload,
                            },
                          });
                        }}
                      >
                        send
                      </span> */}
                    </span>
                  </SeachFormFooter>
                </div>
              </Tab>

            </Tabs>
          </div>
        </TabItemsStyleFooter>
      </form>
    </div>
  );
  // );
}

const stateToProps = (state) => {
  // Fetch the required state properties first
  const selectedAssignedList = chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  );

  return {
    selectedAssignedList,
    messageList: chatSelector.getChatDynamic(state, "messageList"),
    assignedList: chatSelector.getChatDynamic(state, "assignedList"),
    unAssignedList: chatSelector.getChatDynamic(state, "unAssignedList"),
    cannedMessages: chatSelector.getChatDynamic(state, "cannedMessages"),
    paginationInfo: chatSelector.getChatDynamic(state, "paginationInfo"),
    currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
    tagsListDispose: globalStateSelector.getDynamic(state, { key: "tagsList" }),
    callTagList: globalStateSelector.getDynamic(state, { key: "callTagList" }),
    callTagFinalTag: globalStateSelector.getDynamic(state, {
      key: "callTagFinalTag",
    }),
    // Use selectedAssignedList to fetch typingIndicatorCus
    typingIndicatorCus: chatSelector.getTypingStatus(
      state,
      selectedAssignedList.identifier || null
    ),
    dispose: chatSelector.getDisposeScreen(state),
    activeTab: chatSelector.getActiveTab(state),
    messageTagsList: chatSelector.getChatDynamic(state, "messageTagsList"),
    messageSelectedTag: chatSelector.getChatDynamic(state, `messageSelectedTag_${selectedAssignedList.sessionId}`),
    messageCommentTag: chatSelector.getChatDynamic(state, `messageCommentTag_${selectedAssignedList.sessionId}`),
    messageFinalTag: chatSelector.getChatDynamic(state, `messageFinalTag_${selectedAssignedList.sessionId}`),
    messageListTag: chatSelector.getChatDynamic(state, `messageListTag_${selectedAssignedList.sessionId}`),
    disposeList: chatSelector.getChatDynamic(state, "disposeList"),
    listDispose: chatSelector.getChatDynamic(state, "listDispose"),
    currentLevelTagsRedux: chatSelector.getChatDynamic(state, "currentLevelTags"),
    joinLoading: chatSelector.getChatDynamic(state,
      `joinLoading_${selectedAssignedList.sessionId}`
    ) || false,
    isConnected: globalStateSelector.getIsConnected(state),
    isOffline: globalStateSelector.getIsOffline(state),
    messageReply: chatSelector.getChatDynamic(state, `messageReply_${selectedAssignedList.sessionId}`),
    messagePrivate: chatSelector.getChatDynamic(state, `messagePrivate_${selectedAssignedList.sessionId}`),
  };
};

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
  setActiveTab: (data) => {
    dispatch(chatAction.setActiveTab(data));
  },
  setListRedux: (data) => {
    dispatch(chatAction.setListRedux(data));
  },
  setCurrentLevelTagsRedux: (data) => {
    dispatch(chatAction.setCurrentLevelTagsRedux(data));
  },
});
export default connect(stateToProps, dispatchToProps)(MessageScreenFooter);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenFooter/MessageScreenFooter.js